<script>
  import getTranslation from '../../utilities/getTranslation';
  import Icon from '../Icon/Icon.svelte';
  import Heading from '../Heading/Heading.svelte';

  export let componentInformationKeys, subscriptionCards;
</script>

<style lang="scss">
  @use './index' as *;

  .content-wrapper {
    justify-content: center;
    display: flex;
    flex-direction: column;
    width: auto;

    .header {
      text-align: center;
    }

    .subscription-header {
      flex-direction: column;

      &-three-or-more-cards {
        text-align: center;
        display: flex;
        align-items: center;
        width: fit-content;
        margin: 0 auto;

        @include mq($from: desktop) {
          width: 55%;
        }
      }
    }

    .description-items {
      display: flex;
      flex-direction: column;
      margin-block-end: spacing(2);
      margin: 0 auto spacing(2);
      padding: 0 spacing(5);

      @include mq($from: tabletlandscape) {
        margin: 0;
        padding: 0;
      }

      @include mq($from: desktop) {
        text-align: start;
      }

      &-two-cards {
        @include mq($from: 900px, $until: desktop) {
          display: grid;
          grid-template-columns: 38.2rem 38.2rem;
          margin-block-end: spacing(2);
          justify-content: center;
        }

        @include mq($from: desktop) {
          display: block;
        }
      }

      &-three-or-more-cards {
        margin-block-start: spacing(1);

        @include mq($from: tabletlandscape) {
          display: grid;
          grid-template-columns: 38.2rem 38.2rem;
          margin: auto;
          margin-block-end: spacing(2);
        }
      }

      .item-text {
        line-height: 2.4rem;
        margin-block-end: spacing(2);

        &-two-cards {
          @include mq($from: 900px, $until: desktop) {
            padding-inline-start: spacing(4);
          }
          @include mq($from: desktop) {
            padding: 0;
          }
        }

        &-three-or-more-cards {
          @include mq($from: 900px) {
            padding: 0 spacing(4);
          }
        }

        :global(svg) {
          margin-inline-end: spacing(1);
          margin-block-start: -0.6rem;
        }
      }
    }
  }
</style>

<div class="content-wrapper" class:content-wrapper-one-or-two-cards={subscriptionCards < 3}>
  <div class="header">
    <header
      class="subscription-header full-width"
      class:subscription-header-three-or-more-cards={subscriptionCards >= 3}
    >
      <Heading tag="h2" type="title-xl">
        {getTranslation(componentInformationKeys, `priceplans.row1.bullettitle`)}
      </Heading>
    </header>
  </div>
  <ul
    class="description-items"
    class:description-items-three-or-more-cards={subscriptionCards >= 3}
    class:description-items-two-cards={subscriptionCards === 2}
  >
    {#each getTranslation(componentInformationKeys, `priceplans.row1.bullets.v2`).split(';;') as bullet}
      <li
        class="item-text"
        class:item-text-two-cards={subscriptionCards === 2}
        class:item-text-three-or-more-cards={subscriptionCards >= 3}
      >
        <Icon iconName="checkmark" size="24" />{bullet}
      </li>
    {/each}
  </ul>
</div>
